module.exports = __webpack_public_path__ + "img/brand-05.9afbe393.png";